var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChapterCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.518,
    height: 13.691,
    viewBox: "0 0 12.518 13.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Document",
    "data-name": "Iconly/Light-Outline/Document",
    transform: "translate(-2.85 -1.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M8.682,0a3.379,3.379,0,0,1,3.535,3.6V9.788a3.345,3.345,0,0,1-3.508,3.6l-5.174,0A3.38,3.38,0,0,1,0,9.788V3.6A3.344,3.344,0,0,1,3.507,0L8.681,0Zm0,1.009-5.172,0A2.35,2.35,0,0,0,1.009,3.6V9.788a2.353,2.353,0,0,0,2.526,2.594l5.172,0a2.351,2.351,0,0,0,2.5-2.592V3.6A2.353,2.353,0,0,0,8.682,1.009Zm-.13,8.053a.5.5,0,0,1,0,1.009H3.7a.5.5,0,0,1,0-1.009Zm0-2.816a.5.5,0,0,1,0,1.009H3.7a.5.5,0,0,1,0-1.009Zm-3-2.809a.5.5,0,1,1,0,1.009H3.7a.5.5,0,1,1,0-1.009Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChapterCourse);
export default __webpack_public_path__ + "static/media/ChapterCourse.fa0db2ec7a175397e7a57b66cdacf331.svg";
export { ForwardRef as ReactComponent };